import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { ResizeDetectionService } from 'src/app/nutrigenic/services/resize-detection.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    isTablet: boolean = false;
    isMobile: boolean = false;
    isDesktop: boolean = false;

    selectedMasterTab: string | null = 'Home';
    menuItems = new Map<string, string>([
        ['Home', '/home'],
        ['About Us', '/about-us'],
        ['Blog', '/blog'],
        ['Current Menu', '/current-menu'],
        ['How It Works', '/how-it-works'],
        ['For Business', '/ng-for-business'],
        ['My Account', '/profile'],
        ['Privacy Policy', '/privacy'],
        ['Terms & Conditions', '/terms'],
        ['FAQs', '/faq'],
        ['Contact Us', 'mailto:support@nutrigenic.co.uk']
    ]);
    menuItemKeys = Array.from(this.menuItems.keys());
    footer_enabled: boolean = true;
    currentYear = new Date().getFullYear();

    constructor(private router: Router, private sizedetection: ResizeDetectionService) {
        router.events.subscribe(() => {
            this.sizedetection.refreshSize();
            this.sizedetection.sizeCondition$.subscribe(data => {
                this.isDesktop = data.isDesktop;
                this.isTablet = data.isTablet;
                this.isMobile = data.isMobile;
                const hiddenRoutes = ['order-flow', 'order-summary', 'order-checkout', 'select-meals'];
                this.footer_enabled =  !hiddenRoutes.some(route => this.router.url.includes(route));
            });
        });
    }
    
    onItemClick(item: string): void {
        this.selectedMasterTab = item;
        console.log(item);
        const route = this.menuItems.get(item);
        if (route && route.startsWith('mailto:')) {
            window.location.href = route;
        } else if (route) {
            this.router.navigate([route]);
        }
    }

    goToHome() {
        this.router
                .navigate(['/home'])
                .then(() => { })
                .catch(() => { });
    }
    openInNewTab(router: Router, namedRoute: string) {
        let newRelativeUrl = router.createUrlTree([namedRoute]);
        let baseUrl = window.location.href.replace(router.url, '');

        window.open(baseUrl + newRelativeUrl, '_blank');
    }
}
